// A mind map in small, for its tile in All boards: its ideas where the map puts them, sizes guessed from
// their words, its branches in the board's chart colors, the root named.

import { useMemo } from "react";
import { guessSize, ideaText, layoutMap, nodesOf } from "../../../shared/mindmap";
import type { Board, Entry } from "../../../shared/types";

export function MapThumb({ entries }: { board: Board; entries: Entry[] }) {
  const nodes = nodesOf(entries);
  const layout = useMemo(() => layoutMap(nodes, (e, depth) => guessSize(ideaText(e), depth)), [nodes]);
  const b = layout.bounds;
  if (!b) return <span className="ov-empty">Mind map</span>;
  const pad = 40;
  const boxes = [...layout.boxes.values()];
  return (
    <svg className="ov-map" viewBox={`${b.x - pad} ${b.y - pad} ${b.w + pad * 2} ${b.h + pad * 2}`} preserveAspectRatio="xMidYMid meet" aria-hidden>
      {boxes.map((c) => {
        const p = c.parent ? layout.boxes.get(c.parent) : null;
        if (!p || c.id === layout.center) return null;
        const s = c.side || 1;
        const x0 = p.x + s * (p.w / 2);
        const x1 = c.x - s * (c.w / 2);
        const dx = Math.abs(x1 - x0) * 0.55;
        return <path key={c.id} d={`M${x0} ${p.y} C${x0 + s * dx} ${p.y} ${x1 - s * dx} ${c.y} ${x1} ${c.y}`} fill="none" stroke={`var(--chart-${c.color || 1})`} strokeWidth={c.depth === 1 ? 5 : 3} strokeLinecap="round" opacity={0.85} />;
      })}
      {boxes.map((c) =>
        c.id === layout.center ? (
          <g key={c.id}>
            <rect x={c.x - c.w / 2} y={c.y - c.h / 2} width={c.w} height={c.h} rx={16} className="ov-map-root" />
            <text x={c.x} y={c.y} className="ov-map-name" dominantBaseline="central" textAnchor="middle">
              {ideaText(nodes.find((e) => e.id === c.id)).slice(0, 28)}
            </text>
          </g>
        ) : (
          <rect key={c.id} x={c.x - c.w / 2} y={c.y - c.h / 2} width={c.w} height={c.h} rx={c.depth === 1 ? 11 : 8} className={c.depth === 1 ? "ov-map-branch" : "ov-map-idea"} />
        ),
      )}
    </svg>
  );
}
